import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csmethod(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Method tutorial For Beginners</title>
 <meta name="description" content="C# Method tutorial for beginners.The c# methods contain one more statement and each method performs only one task, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Method,c# Method for,c sharp Method,c# foreach Method,Method call in Csharp(C#)" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-method" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C# Method</h1>
    <div className="first">
        <a href="/csharp-class-object">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-user-define-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1,The C# Methods contain one more statement and each method performs only one task
        <br/>
        2,Each method gives the name and after this name is used to call the method.  
    </p>
  

<h2 className='headings'>Methods in C# Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
          <span className="qwerty-4">Method </span>
            <span className="qwerty-5">name</span>
            <span className="qwerty-4"> (</span>
            <span className="qwerty-7">parenthesis</span>
            <span className="qwerty-4"> or </span>
            <span className="qwerty-6">parameter</span>
            <span className="qwerty-7"> -list</span>
            <span className="qwerty-5">)</span>
            {"\n"}
            <span className="qwerty-3">&#123;</span>
            {"\n"}
            <span className="qwerty-4">//</span>
            <span className="qwerty-5"> body of method</span>
            {"\n"}
            <span className="qwerty-3">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className='headings'>Q-Write a Program use one method in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">school </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty">void </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-1">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">teaching</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-6">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">start</span>
            <span className="qwerty-4"> method</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">school</span>
            <span className="qwerty-2"> s </span>
            <span className="qwerty-7"> = </span>
            <span className="qwerty-3">new</span>
            <span className="qwerty-4"> school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">s.</span>
            <span className="qwerty-5">teachers</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">start </span>
              <span className="qwerty-10">method </span>
              {"\n"}
              <span className="qwerty-5">teaching </span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>






<h2 className='headings'>Q-Write a Program Use two methods and create different objects for different methods in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">school </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">public </span>
            <span className="qwerty">void </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-1">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">teaching</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">public </span>
            <span className="qwerty">void </span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-1">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">learn</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-6">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">start</span>
            <span className="qwerty-4"> method</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">school</span>
            <span className="qwerty-2"> s </span>
            <span className="qwerty-7"> = </span>
            <span className="qwerty-3">new</span>
            <span className="qwerty-4"> school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">s.</span>
            <span className="qwerty-5">teachers</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-2">//</span>
            <span className="qwerty-7"> first method</span>
            {"\n"}
            <span className="qwerty-2">s.</span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-2">//</span>
            <span className="qwerty-7"> second method</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">start </span>
              <span className="qwerty-10">method </span>
              {"\n"}
              <span className="qwerty-5">teaching </span>
              {"\n"}
              <span className="qwerty-4">learn</span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>

<h2 className="mt-4 mh2">important:</h2>
<p className="mt-4 para">You create multiple objects you do but programming run speed is decreased so create less object to gain high speed. 
</p>



<h2 className='headings'>Q-Write a Program use different class on C# Method Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">school </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">public </span>
            <span className="qwerty">void </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-1">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">teaching</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-6">public </span>
            <span className="qwerty">void </span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-1">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">learn</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-6">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">start</span>
            <span className="qwerty-4"> method</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">school</span>
            <span className="qwerty-2"> s</span>
            <span className="qwerty-7"> = </span>
            <span className="qwerty-3">new</span>
            <span className="qwerty-4"> school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-2">//</span>
            <span className="qwerty-7"> create new object</span>
            {"\n"}
            <span className="qwerty-4">school</span>
            <span className="qwerty-2"> t</span>
            <span className="qwerty-7"> = </span>
            <span className="qwerty-3">new</span>
            <span className="qwerty-4"> school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-2">//</span>
            <span className="qwerty-7"> create other new object</span>
            {"\n"}
            <span className="qwerty-4">schoolPeon</span>
            <span className="qwerty-2"> p</span>
            <span className="qwerty-7"> = </span>
            <span className="qwerty-3">new</span>
            <span className="qwerty-4"> schoolPeon </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">s.</span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">s.</span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">p.</span>
            <span className="qwerty-5">peon </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">schoolPeon </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty">void </span>
            <span className="qwerty-5">peon </span>
            <span className="qwerty-1">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">this</span>
              <span className="qwerty-2"> is </span>
              <span className="qwerty-7">peon</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">start </span>
              <span className="qwerty-10">method </span>
              {"\n"}
              <span className="qwerty-5">teaching </span>
              {"\n"}
              <span className="qwerty-4">learn </span>
              {"\n"}
              <span className="qwerty-1">this</span>
              <span className="qwerty-2"> is </span>
              <span className="qwerty-7">peon</span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>


<h3 className="mt-4 mh3">Multiple classes in c# Steps follow </h3>
<p className="mt-4 para">If you create multiple classes in one program and call methods  from all classes so firstly you check in which class you write main() method and after you create multiple objects from multiple classes inside main () method class  and after by the name of an object call method from main () method class
</p>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-class-object">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-user-define-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csmethod;